import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthProvider';
import { HOME_ROUTE } from '../../utils/redirect';

/**
 * Route gate for a single feature grant. Sits inside ProtectedRoute, which has
 * already established that a session exists — this narrows that to "and holds
 * this grant".
 *
 * Without it, a route is reachable by anyone signed in: ProtectedRoute checks
 * only isLoggedIn, so hiding a nav entry left the URL itself open. A VIEWER
 * could type /uploads and get the page, and /settings rendered its shell even
 * though every request it makes is refused.
 *
 * Like ProtectedRoute, this is a UX gate and NOT the security boundary — the
 * backend's verifyJWT + verifyFeature are. A route closed here must also be
 * closed there; this only stops the app offering a page it cannot serve.
 *
 * Denial is a silent redirect to HOME_ROUTE, matching how the unknown-path
 * catch-all already behaves, rather than a dedicated 403 screen.
 */
const RequirePermission = ({ feature, permission = 'read' }) => {
  const { checkPermission } = useAuthContext();

  if (!checkPermission(feature, permission)) {
    return <Navigate to={HOME_ROUTE} replace />;
  }

  return <Outlet />;
};

export default RequirePermission;
